import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Box from '../components/Box'
import LoadingProgress from '../components/LoadingProgress'

import { fetchMatrixs } from '../actions/matrixs'

import MatrixList from '../components/MatrixList'
import BluetoothList from '../components/BluetoothList'
import ErrorMessage from '../components/ErrorMessage'

class MatrixsView extends React.Component {
  constructor(props) {
    super(props)

  }

  componentDidMount() {
    this.props.fetchMatrixs('')
  }

  renderMatrixs() {
    const { matrixs, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message}/>)
    }

    if (!matrixs || loading) {
      return <LoadingProgress />
    }

    return (
      <MatrixList matrixs={matrixs} />
    )
  }

  renderBluetooth() {
    const { matrixs, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message}/>)
    }

    if (!matrixs || loading) {
      return <LoadingProgress />
    }

    return (
      <BluetoothList matrixs={matrixs} />
    )
  }

  render() {  

    return (
      <div>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <h1 className="text-vw-dark">
              VERSIONES DE FIRMWARE EN CENTRALITAS
            </h1>
          </div>
        </div>
        <Box>
          { this.renderMatrixs() }
        </Box>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <h1 className="text-vw-dark">
              FALLOS DE BLUETOOTH
            </h1>
          </div>
        </div>
        <Box>
          { this.renderBluetooth() }
        </Box>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  matrixs: state.matrixs.matrixs,
  error: state.matrixs.error,
  loading: state.matrixs.loading,
  role: state.auth.role,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchMatrixs: bindActionCreators(fetchMatrixs, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(MatrixsView)
